<template>
  <header class="bg-[#1f2937] border-b border-gray-700 flex justify-between items-center px-4 py-2">
    <!-- Lado izquierdo: botón menú y logo principal -->
    <div class="flex items-center gap-4">
      <button class="md:hidden text-white text-2xl" @click="$emit('toggle-sidebar')">☰</button>
      <img
        alt="Sinergy Group"
        src="@/components/imgs/logo-sinergy-blanco.png"
        class="h-12 w-auto"
      />
    </div>

    <!-- Lado derecho: usuario, cerrar sesión y logo empresa -->
    <div class="flex items-center gap-3 sm:gap-4">
      <span
        v-if="authStore.nombreVisible"
        class="hidden sm:inline text-sm text-gray-200 truncate max-w-[12rem]"
        :title="authStore.nombreVisible"
      >
        {{ authStore.nombreVisible }}
      </span>

      <button
        type="button"
        :disabled="cerrando"
        class="text-xs sm:text-sm text-white border border-gray-500 rounded px-2 py-1
               hover:bg-[#FF6600] hover:border-[#FF6600] transition-colors
               disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap"
        @click="cerrarSesion"
      >
        {{ cerrando ? 'Saliendo…' : 'Cerrar sesión' }}
      </button>

      <img
        alt="Logo Empresa"
        src="@/components/imgs/logo2.png"
        class="h-12 w-auto"
      />
    </div>
  </header>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { authStore } from "@/stores/authStore.js";

defineEmits(["toggle-sidebar"]);

const BACKEND_URL =
  process.env.VUE_APP_BACKEND_URL || "http://localhost:8081";

const router = useRouter();
const cerrando = ref(false);

async function cerrarSesion() {
  if (cerrando.value) return;

  cerrando.value = true;

  try {
    await axios.post(`${BACKEND_URL}/auth/logout`);
  } catch (e) {
    // Aunque falle la llamada, la sesión local se cierra igual.
  } finally {
    authStore.limpiar();
    cerrando.value = false;
    router.replace("/login");
  }
}
</script>
